import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../core';

@Injectable()
export class LandingPageApiService extends ApiService {
  constructor(protected override readonly httpClient: HttpClient) {
    super(httpClient, "/api/landing-pages");
  }
}
